const numberWithCommas = num => Number(num).toLocaleString();

export default numberWithCommas;